import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export const settingsService = {
    getAll,
    getById,
    getByKey,
    update,
    updateAll,
    getPages,
    findShippingZone,
    getShippingCost,
    getAllZone
};

function getAll() {

        const baseUrl = window.location.origin;
        const url = `${baseUrl}/wp-json/wc/v3/shipping/zones`;
    
        const requestConfig = {
            method: 'GET',
            headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
        };
    
        return fetch(url, requestConfig)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch shipping zones');
                }
                return response.json();
            })
            .then(zones => {
                if (zones.length === 0) {
                    console.error('No shipping zones found');
                    return [];
                }
    
                const zonePromises = zones.map(zone => {
                    const zoneId = zone.id;
                    const zoneUrl = `${baseUrl}/wp-json/wc/v3/shipping/zones/${zoneId}/methods`;
                    const zoneRequestConfig = {
                        method: 'GET',
                        headers: oauthFunction().toHeader(oauthFunction().authorize({ url: zoneUrl, method: 'GET' }))
                    };
    
                    return fetch(zoneUrl, zoneRequestConfig)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(`Failed to fetch shipping methods for zone ${zoneId}`);
                            }
                            return response.json();
                        })
                        .then(methods => {
                            // Extract pricing information for each shipping method
                            const methodsWithPrices = methods.map(method => {
                                const methodData = {
                                    id: method.id,
                                    title: method.title,
                                    cost: method.settings.cost || 0, // Assuming 'cost' is the key for the shipping price
                                    // Add other relevant properties here
                                };
    
                                if (method.method_id === 'free_shipping') {
                                    methodData.minimumOrderAmount = method.settings.min_amount || 0;
                                }
    
                                return methodData;
                            });
    
                            return {
                                id: zoneId,
                                name: zone.name,
                                methods: methodsWithPrices,
                            };
                        });
                });
    
                return Promise.all(zonePromises);
            })
            .catch(error => {
                console.error('Error fetching shipping zones with prices and free shipping:', error);
                return [];
            });
    }


    function getAllZone() {
        const baseUrl = window.location.origin;
        const url = `${baseUrl}/wp-json/wc/v3/shipping/zones`;
    
        const requestConfig = {
            method: 'GET',
            headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
        };
    
        return fetch(url, requestConfig)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch shipping zones');
                }
                return response.json();
            })
            .then(zones => {
                if (zones.length === 0) {
                    console.error('No shipping zones found');
                    return [];
                }
    
                const zonePromises = zones.map(zone => {
                    const zoneId = zone.id;
                    const zoneUrl = `${baseUrl}/wp-json/wc/v3/shipping/zones/${zoneId}/locations`;
                    const zoneRequestConfig = {
                        method: 'GET',
                        headers: oauthFunction().toHeader(oauthFunction().authorize({ url: zoneUrl, method: 'GET' }))
                    };
    
                    return fetch(zoneUrl, zoneRequestConfig)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(`Failed to fetch locations for zone ${zoneId}`);
                            }
                            return response.json();
                        })
                        .then(locations => {
                            zone.locations = locations; // Store locations in the zone object
    
                            // Fetch methods for the zone
                            const zoneMethodsUrl = `${baseUrl}/wp-json/wc/v3/shipping/zones/${zoneId}/methods`;
                            const zoneMethodsRequestConfig = {
                                method: 'GET',
                                headers: oauthFunction().toHeader(oauthFunction().authorize({ url: zoneMethodsUrl, method: 'GET' }))
                            };
    
                            return fetch(zoneMethodsUrl, zoneMethodsRequestConfig)
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error(`Failed to fetch methods for zone ${zoneId}`);
                                    }
                                    return response.json();
                                })
                                .then(methods => {
                                    zone.methods = methods; // Store methods in the zone object
                                    return zone;
                                });
                        });
                });
    
                return Promise.all(zonePromises);
            })
            .catch(error => {
                console.error('Error fetching shipping zones with locations:', error);
                throw error;
            });
    }
    
    function findShippingZone(zones, billingInfo, orderAmount) {
        // Construct the location code for the billing state
        const billingLocationCode = `${billingInfo.country}:${billingInfo.state.toUpperCase()}`;
        //console.log(`Billing Location Code: ${billingLocationCode}`);
    
        let matchingZone = null;
        let convertOrderAmount = orderAmount / 100;
        //console.log(convertOrderAmount)
    
        // First, try to find a zone that offers free shipping
        zones.forEach(zone => {
            if (zone.locations) {
                const zoneLocationCodes = zone.locations.map(location => location.code.toUpperCase());
                //console.log(`Zone ${zone.name} Location Codes: ${zoneLocationCodes}`);
    
                // Check if the current zone matches the billing location
                if (zoneLocationCodes.includes(billingLocationCode)) {
                    // Check if this zone has free shipping
                    zone.methods.forEach(method => {
                        if (method.method_id === 'free_shipping' && convertOrderAmount >= parseFloat(method.settings.min_amount.value)) {
                            //console.log(`Free shipping method found in zone: ${zone.name} (Minimum amount: ${method.settings.min_amount.value})`);
                            matchingZone = zone; // Prioritize the zone with free shipping
                        }
                    });
                }
            }
        });
    
        // If no zone with free shipping is found, find the default zone based on billing location
        if (!matchingZone) {
            matchingZone = zones.find(zone => {
                if (zone.locations) {
                    const zoneLocationCodes = zone.locations.map(location => location.code.toUpperCase());
                    return zoneLocationCodes.includes(billingLocationCode);
                }
                return false; // Return false if locations property is undefined
            });
        }
    
        return matchingZone;
    }
    
    function getShippingCost(customerBillingInfo, orderAmount) {
        //console.log('Customer Billing Info:', customerBillingInfo);
        //console.log('Order Amount:', orderAmount); // Log the order amount
    
        return getAllZone()
            .then(zones => {
                //console.log('All Shipping Zones:', zones); // Log all zones
                
                const shippingZone = findShippingZone(zones, customerBillingInfo, orderAmount); // Pass orderAmount here
                if (!shippingZone) {
                    throw new Error('No matching shipping zone found for the given billing address');
                }
    
                //console.log('Matched Shipping Zone:', shippingZone); // Log matched zone
    
                const shippingCosts = shippingZone.methods.map(method => {
                    //console.log('Shipping Method:', method); // Log each method
                    
                    let cost = 0;
    
                    // Check if it's free shipping
                    if (method.method_id === 'free_shipping') { // Check if method ID is 'free_shipping'
                        const minAmountSetting = method.settings.min_amount ? parseFloat(method.settings.min_amount.value) : 0;
    
                        //console.log(`Free shipping method found. Minimum amount: ${minAmountSetting}`);
                        
                        if (orderAmount >= minAmountSetting) {
                            console.log(`Free shipping available. Your order amount: ${orderAmount}`);
                            return {
                                methodId: method.id,
                                title: method.title,
                                cost: 0,  // Free shipping
                            };
                        } else {
                            //console.log(`Free shipping not available. Minimum amount required: ${minAmountSetting}`);
                            return {
                                methodId: method.id,
                                title: method.title,
                                cost: 'Minimum order not met for free shipping',
                            };
                        }
                    }
    
                    // Regular shipping cost
                    if (method.settings && method.settings.cost && method.settings.cost.value) {
                        cost = parseFloat(method.settings.cost.value);
                        if (isNaN(cost)) {
                            console.warn(`Invalid cost value "${method.settings.cost.value}" for method ${method.id}`);
                        }
                    }
    
                    return {
                        methodId: method.id,
                        title: method.title,
                        cost: cost,
                    };
                });
    
                return shippingCosts;
            })
            .catch(error => {
                console.error('Error determining shipping cost:', error);
                throw error;
            });
    }
    
    
    
    
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/settings/`+id, requestOptions).then(handleResponse);
}

function getByKey(type) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    
    return fetch(Config.api.basepath+`/settings?filter=payment_method:` + type, requestOptions).then(handleResponse)  
}

function update(body) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: body
    };
    
    return fetch(Config.api.basepath+`/settings/` + body._id, requestOptions).then(handleResponse)  
}

function updateAll(body) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(body)
    };
    
    return fetch(Config.api.basepath+`/settings`, requestOptions).then(handleResponse)  
}



// const fetchShippingMethods = (shipping) => {
//     return new Promise((resolve, reject) => {
//         const baseUrl = window.location.origin;
//         let url = `${baseUrl}/wp-json/wc/v3/shipping/zones`;

//         const requestConfig = {
//             method: 'GET',
//             headers: oauthFunction().toHeader(oauthFunction().authorize({ url, method: 'GET' }))
//         };

//         fetch(url, requestConfig)
//             .then(response => {
//                 if (!response.ok) {
//                     throw new Error('Failed to fetch shipping methods');
//                 }
//                 return response.json();
//             })
//             .then(zones => {
//                 // Assuming you need to find the appropriate zone for the shipping address
//                 const promises = zones.map(zone => {
//                     return fetch(`${url}/${zone.id}/methods`, requestConfig)
//                         .then(response => response.json());
//                 });
//                 return Promise.all(promises);
//             })
//             .then(shippingMethods => {
//                 const selectedMethod = shippingMethods.flat().find(method => method.enabled); // Adjust the logic as needed
//                 resolve(selectedMethod ? parseFloat(selectedMethod.cost) : 0);
//             })
//             .catch(error => {
//                 console.error('Error fetching shipping methods:', error);
//                 reject(error);
//             });
//     });
// };


function oauthFunction() {
    
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });


    return oauth
}


function getPages(slug) {
    return fetch(`/wp-json/wp/v2/pages?slug=${slug}`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to fetch page');
            }
            return response.json();
        })
        .catch(error => {
            console.error('Error fetching page:', error);
            return null;
        });
}






function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
